import { formatHourMinutesRange } from 'utils/l10n';

export const formatOpeningHours = (venueHours) => {
  let todayInfo;

  if (venueHours?.temporarilyClosed) {
    todayInfo = 'Temporarily closed';
  } else {
    const todayOpeningHours = venueHours?.projectedDays[0];

    if (todayOpeningHours) {
      const {
        openHour,
        openMinute = 0,
        closeHour,
        closeMinute = 0,
        isClosed,
      } = todayOpeningHours;

      // if only today is temporarily closed
      if (isClosed) {
        todayInfo = 'Temporarily closed';
      } else {
        const hoursRange = formatHourMinutesRange(
          openHour,
          openMinute,
          closeHour,
          closeMinute
        );
        todayInfo = `Open hours: ${hoursRange}`;
      }
    } else {
      todayInfo = `Hours not available`;
    }
  }
  return todayInfo;
};

export const isVenueClosed = (venueHours) => {
  const todayOpeningHours =
    venueHours.projectedDays && venueHours.projectedDays[0];

  if (venueHours.temporarilyClosed || !todayOpeningHours) {
    return true;
  } else {
    const {
      openHour,
      openMinute = 0,
      closeHour,
      closeMinute = 0,
    } = todayOpeningHours;

    // Date now to compare
    const localDate = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York',
    });
    const today = new Date(localDate);
    const hourNow = today.getHours();
    const minutesNow = today.getMinutes();

    if (hourNow > openHour && hourNow < closeHour) {
      // Hour now between venue open hour range
      return false;
    } else if (
      (hourNow === openHour && minutesNow > openMinute) ||
      (hourNow === closeHour && minutesNow < closeMinute)
    ) {
      // Hour now can be equal to venue open hour limit
      return false;
    } else {
      // if not, venue is closed
      return true;
    }
  }
};
